import { useState } from "react";

const useTemplatePickerHook = (template) => {
	const [selectedTemplateConfiguration, setSelectedTemplateConfiguration] = useState({
		chapters: [],
		contents: [],
		goals: [],
		reqs: [],
	});

	return {
		selectedTemplateConfiguration,
		setSelectedTemplateConfiguration,
	};
};

export default useTemplatePickerHook;
